import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

const usePatientLabel = () => {

  const patientId = useCurrentPatientId();

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientLabel", patientId, tenantVal],
    queryFn: async () => {
      if (!patientId || !tenantVal) return null;
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patient/download/label/${patientId}`,
        {
          responseType: "blob",
        }
      );

      return response.data;
    },
    enabled: !!patientId && !!tenantVal,
    meta: { errorMessage: "Error fetching patient label" },
  });
};

export { usePatientLabel };